import { render, staticRenderFns } from "./preformatted-editor-action-clear-template.vue?vue&type=template&id=537b7dcc&scoped=true&"
import script from "./preformatted-editor-action-clear-template.ts?vue&type=script&lang=ts&"
export * from "./preformatted-editor-action-clear-template.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-editor-action-clear-template.scss?vue&type=style&index=0&id=537b7dcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b7dcc",
  null
  
)

export default component.exports